import { createSlice } from '@reduxjs/toolkit';

import { getToken, generateDeepLink, callNotificationVOIP, customCloudMessage } from "../MentalHealth/pages/ActiveChats/apis/index"
import { database, databaseRef } from 'utils/firebase'
import { push, set, update, get, ref, child } from 'firebase/database';

const initialState = { 
    manageCallData:{},
    callJoiningStatus: false,
    localTracks: [],
    isMicMuted: false,
    isCameraOff: false
}


const slice = createSlice({
    name: 'callData',
    initialState: initialState,
    reducers: {
        setManageCallData: (state, action) => {
            state.manageCallData = action.payload;
        },
        setCallJoiningStatus: (state, action) =>  ({
            ...state,
            callJoiningStatus: action.payload,
            
          }),
        setLocalTracks: (state, action) => {
            state.localTracks = action.payload;
        },
        setMicMuted: (state, action) => {
            state.isMicMuted = action.payload;
        },
        setCameraOff: (state, action) => {
            state.isCameraOff = action.payload;
        }

    },

});


export const manageCall = (key) => (dispatch) => {
    try {
        dispatch(
            slice.actions.setManageCallData(key || null),
        )
    } catch (e) {
        console.log(e)
    }
}

export const startAgoraCall = (callType, currentSession, me, patientProfile, agoraInstance, setCallLoading, setCurrentCallType) => async (dispatch) => {
    try{
        setCurrentCallType(callType) // Update hook call type
        // Set Agora singleton call type and channel ID
        agoraInstance.setCallType(callType)
        setCallLoading(true)
        // const callLogsSnap = await get(ref(database, `callLogs/${currentSession?.currentSessionID}`));
        // let callLogs = callLogsSnap.exists() ? callLogsSnap.val() : {}
        let doctorToken = null
        let patientToken = null
        let deeplink = null
        if (!doctorToken) {
          const obj = {
            uid: 1,
            channelName: currentSession?.currentSessionID,
          }
          const doctorTokenResponse = await getToken(obj)
          doctorToken = doctorTokenResponse?.rctToken
        }
        if (!patientToken) {
          const obj = {
            uid: 2,
            channelName: currentSession?.currentSessionID,
          }
          const patientTokenResponse = await getToken(obj)
          patientToken = patientTokenResponse?.rctToken
        }
        let notificationPayload = {
          notificationToken: patientProfile?.notificationToken,
          data: {
            name: me?.doctorName,
            conversationID: currentSession?.currentSessionID || null,
            profileImageUrl: me?.profileImageURL,
            ReminderType: callType,
            channelToken: patientToken,
            channelName: currentSession?.currentSessionID,
            uid: '2',
            isMentalHealth: true,
          },
        }
        let voipNotificationPayload = {
          production: process.env.NODE_ENV !== 'development',
          token: patientProfile?.voipToken,
          payload: {
            name: me?.doctorName,
            conversationID: currentSession?.currentSessionID || null,
            profileImageUrl: me?.profileImageURL,
            reminderType: callType,
            channelToken: patientToken,
            channelName: currentSession?.currentSessionID,
            uid: '2',
            isMentalHealth: true,
          },
        }
        if (currentSession?.currentSessionID) {
          console.log('in convo')
          if (
            !deeplink /*&& (props?.selectedPatient?.platform).toLowerCase() === "web"*/
          ) {
            const deeplinkPayload = {
              domain: 'https://app.yourdoctors.online/',
              params: {
                channelToken: encodeURIComponent(patientToken),
                channelName: encodeURIComponent(
                  currentSession?.currentSessionID,
                ),
                uid: '2',
                type: encodeURIComponent(callType),
                conversationId: encodeURIComponent(
                  currentSession?.currentSessionID,
                ),
                name: encodeURIComponent(me?.doctorName),
                profileImageUrl: encodeURIComponent(me?.profileImageURL),
              },
            }
            console.log('deeplinkPayload ', JSON.stringify(deeplinkPayload))
            const deeplinkResponse = await generateDeepLink(deeplinkPayload)
            let domain = 'http://localhost:3002/'
            let keys = Object.keys(deeplinkPayload.params)
            let values = Object.values(deeplinkPayload.params)
            let redirectUrl = domain
            if (keys.length > 0) {
              redirectUrl += '?'
            }
            keys.forEach((key, index) => {
              redirectUrl += `${key}=${encodeURIComponent(values[index])}`
              if (index !== keys.length - 1) {
                redirectUrl += '&'
              }
            })
            console.log({ redirectUrl })
            deeplink = deeplinkResponse?.data?.referralLink
          }
  
          const content = `Hi I'm waiting for you in the call, please join and complete your consult`
          let messageValue = {
            type: callType,
            content: content,
            fromID: me?.id || currentSession?.doctorID || null,
            toID: currentSession?.patientID,
            isRead: false,
            doctorName: me?.doctorName,
            doctorImgURL:  'https://placehold.co/600x400' || me?.profileImageURL || null,
            additionalData: {
              channelToken: patientToken,
              channelName: currentSession?.currentSessionID,
              uid: '2',
              deeplink: deeplink,
              isMentalHealth: true,
            },
            timestamp: Date.now(),
          }

          const conversationRef = ref(database, `mentalHealthConversations/${currentSession?.conversationID}`);
          const newMessageKey = push(conversationRef).key;
  
          let updates = {};
          if (currentSession?.conversationID) {
            updates[
              `/mentalHealthConversations/${currentSession?.conversationID}/${newMessageKey}`
            ] = messageValue
          }
          updates[`/callLogs/${currentSession?.currentSessionID}/status`] =
            'initiated'
          updates[
            `/callLogs/${currentSession?.currentSessionID}/patientChannelToken`
          ] = patientToken
          updates[
            `/callLogs/${currentSession?.currentSessionID}/channelName`
          ] = currentSession?.currentSessionID
          updates[
            `/callLogs/${currentSession?.currentSessionID}/patientUid`
          ] = '2'
          updates[
            `/callLogs/${currentSession?.currentSessionID}/doctorName`
          ] = me?.doctorName
          updates[
            `/callLogs/${currentSession?.currentSessionID}/profileImageUrl`
          ] = me?.profileImageURL || null
          updates[
            `/callLogs/${currentSession?.currentSessionID}/doctorChannelToken`
          ] = doctorToken
          updates[
            `/callLogs/${currentSession?.currentSessionID}/doctorUid`
          ] = '1'
          updates[
            `/callLogs/${currentSession?.currentSessionID}/hostStatus`
          ] = 'available'
          updates[
            `/callLogs/${currentSession?.currentSessionID}/deeplink`
          ] = deeplink
          updates[
            `/callLogs/${currentSession?.currentSessionID}/callType`
          ] = callType
          updates[
            `/callLogs/${
              currentSession?.currentSessionID
            }/events/${Date.now()}`
          ] = 'initiated'
          await update(ref(database), updates)
          const obj = {
            engageCall: true,
            callType: callType,
            token: doctorToken,
            channelName: currentSession?.currentSessionID,
            account: 1
          }
          dispatch(slice.actions.setManageCallData(obj))
        }
  
        if ((patientProfile?.platform).toLowerCase() === 'ios') {
          
          if (patientProfile?.voipToken) {
            console.log(
              'getAgoraToken notificationPayload',
              JSON.stringify(voipNotificationPayload),
            )
            const voipNotificationResponse = await callNotificationVOIP(
                JSON.stringify(voipNotificationPayload),
            )
          }
        }else{
            if (patientProfile?.notificationToken) {
                console.log(
                  'getAgoraToken notificationPayload',
                  JSON.stringify(notificationPayload),
                )
                setTimeout(async () => {
                  const notificationResponse = await customCloudMessage(
                    JSON.stringify(notificationPayload),
                  )
                }, 3000)
              }
        }
        
  
        // discuss with shayan i think this function is not use
  
        // props.startAgoraCall({ rctToken: doctorToken, channelName: conversationID, callType: callType === "audioCall" ? "audio" : "video", conversationId: conversationID })
        setCallLoading(false)
      } catch (error) {
        const obj = {
          engageCall: false,
        }
        dispatch(slice.actions.setManageCallData(obj))
        console.log('Error getting Call logs', error)
        setCallLoading(false)
        alert(error.message || 'Call failed! Please try again')
      }
}

export const setCallJoiningStatus = (status) => (dispatch) => {
    dispatch(
        slice.actions.setCallJoiningStatus(status),
    )
}

export const addLocalTracks = (tracks) => (dispatch, getState) => {
  console.log('addLocalTracks tracks ', tracks)
  const { localTracks, isMicMuted, isCameraOff } = getState().callData
  tracks.forEach((track) => {
    if (track.trackMediaType === 'audio') {
      track.setEnabled(!isMicMuted)
    }
    if (track.trackMediaType === 'video') {
      track.setEnabled(!isCameraOff)
    }
  })
  dispatch(slice.actions.setLocalTracks([...localTracks, ...tracks]))
}

export const closeTracks = () => (dispatch, getState) => {
  const { localTracks } = getState().callData
  localTracks.forEach((track) => {
    console.log('closeTracks track ', track)
    track.close()
  })
  dispatch(slice.actions.setLocalTracks([]))
}

export const setMuteCamera = (status) => (dispatch, getState) => {
  const { localTracks, isCameraOff } = getState().callData

  localTracks.forEach((track) => {
    if (track.trackMediaType === 'video') {
      // Toggle the enabled state of the video track
      track.setEnabled(isCameraOff)
    }
  })

  // Update the Redux state with the new camera status
  dispatch(slice.actions.setCameraOff(!isCameraOff))
  dispatch(slice.actions.setLocalTracks(localTracks))
}

export const setMuteMic = (status) => (dispatch, getState) => {
  const { localTracks, isMicMuted } = getState().callData
  localTracks.forEach((track) => {
    if (track.trackMediaType === 'audio') {
      // Toggle the enabled state of the audio track
      track.setEnabled(isMicMuted)
    }
  })

  dispatch(slice.actions.setLocalTracks(localTracks))
  dispatch(slice.actions.setMicMuted(!isMicMuted))
}


export const actions = {
    manageCall,
    startAgoraCall,
    setCallJoiningStatus,
    addLocalTracks,
    closeTracks,
    setMuteCamera,
    setMuteMic
}

export default slice.reducer;